import Analytics from 'aria-viewer/analytics/utils/analytics'
import BlockingEvents from '../utils/blockingEvents'
import $ from 'jquery'

var Common = {
        screen_modes: {
            DESKTOP: 0,
            MOBILE: 1,
        },

        img_assets_url: '',

        // Mobile or destkop
        screen_mode: -1,

        register_share: {
            DESKTOP: 0,
            MOBILE: 0,
            customShareParamsCB: undefined,
            desktopShareParams: undefined,
            mobileShareParams: undefined,
        },

        _blockingEvents: null,

        _screenSizeModeChange: [],
        mobileShareObject: [],
        shareObject: [],

        init: function() {
            if (BlockingEvents !== undefined) {
                this._blockingEvents = new BlockingEvents()
            }
            if ($('#orientation').length == 0 && !$('.mediaType').data('mediatype'))
                $('body').append("<div id='orientation'><div></div></div>")

            this._setScreenSizeMode()

            $(window)
                .on('resize', this._onWindowSizeChange.bind(this))
                .on('orientationchange', this._onWindowSizeChange.bind(this))

            $(document).ready(this._documentInit.bind(this))
        },

        requestEventLock: function(event, scope) {
            return this._blockingEvents.requestLock(event, scope)
        },

        releaseEventLock: function() {
            this._blockingEvents.releaseLock()
        },

        onScreenSizeModeChange: function(cb) {
            this._screenSizeModeChange.push(cb)
        },

        appendPlatformParam: function(url, platformKey) {
            if (url == '#' || url.indexOf('pl=') > -1) {
                return url
            }
            if (platformKey === undefined) {
                platformKey = $('#data-variables').attr('data-platform-key')
            }
            if (
                platformKey === undefined ||
                platformKey === '' ||
                platformKey === 'w' || // No need to add platform param for WEB
                url === undefined ||
                url === '' ||
                url.toLowerCase().indexOf('javascript') >= 0
            ) {
                return url
            }

            var connector = '&'
            if (url.indexOf('?') < 0) {
                connector = '?'
            }
            url += connector + 'pl=' + platformKey
            return url
        },

        _setScreenSizeMode: function() {
            var newMode = $('body').attr('data-share-screen-mode')
            if (typeof newMode == 'undefined')
                newMode =
                    $('body > #container').width() <= 768
                        ? $('body .content').width() <= 768
                            ? this.screen_modes.MOBILE
                            : this.screen_modes.DESKTOP
                        : this.screen_modes.DESKTOP
            else newMode = parseInt(newMode)
            if (newMode !== this.screen_mode) {
                this.screen_mode = newMode
                this._fireScreenSizeModeChange()

                if (this.register_share.customShareParamsCB != undefined) {
                    this.registerShareObject(
                        this.register_share.desktopShareParams,
                        this.register_share.mobileShareParams,
                        this.register_share.customShareParamsCB,
                        false
                    )
                }
            }
        },

        _fireScreenSizeModeChange: function() {
            for (var i = 0; i < this._screenSizeModeChange.length; i++) {
                this._screenSizeModeChange[i]()
            }
        },

        _onWindowSizeChange: function() {
            this._setScreenSizeMode()
        },

        _documentInit: function() {
            var buttons

            setupPlatformParams()
            setupCloseButton()

            buttons = {
                'a.apply': {
                    action: 'apply',
                    new_window: true,
                },
                'a.schedule': {
                    action: 'visit',
                    new_window: true,
                },
                'a.learn': {
                    action: 'info',
                    new_window: true,
                },
                'a.powered-by': {
                    action: 'poweredby',
                    new_window: true,
                },
            }

            for (const button in buttons)
                attachRegisterEventToButton(button, buttons[button]['action'], buttons[button]['new_window'])

            this.img_assets_url = $('#data-variables').attr('data-image-path')

            // Disables context menu on right clicking of images
            $('body').on('contextmenu', 'img', function(e) {
                return false
            })
        },

        /*
			Function expects shareParams object for desktop and mobile and a callback function to register the url. 
			The params object will have a selector for shareButton and shareLi
		*/
        registerShareObject: function(desktopParams, mobileParams, customPageParamsFunc, multiple) {
            var shareParams = null
            this.register_share.desktopShareParams = desktopParams
            this.register_share.mobileShareParams = mobileParams

            if (
                this.screen_mode == this.screen_modes.DESKTOP &&
                desktopParams.shareButton.length > 0 &&
                (multiple || this.shareObject.length == 0)
            ) {
                shareParams = desktopParams
                this.register_share.DESKTOP = 1
                this.register_share.MOBILE = 0
                var sharedObject = new ShareObject(shareParams.shareLi, shareParams.shareButton, customPageParamsFunc)
                this.shareObject.push(sharedObject)
                sharedObject.addClickEvents()
                this.mobileShareObject = []
            } else if (
                this.screen_mode == this.screen_modes.MOBILE &&
                mobileParams.shareButton.length > 0 &&
                (multiple || this.mobileShareObject.length == 0)
            ) {
                shareParams = mobileParams
                this.register_share.MOBILE = 1
                this.register_share.DESKTOP = 0
                var mobileShareObject = new ShareObject(
                    shareParams.shareLi,
                    shareParams.shareButton,
                    customPageParamsFunc
                )
                this.mobileShareObject.push(mobileShareObject)
                mobileShareObject.addClickEvents()
                this.shareObject = []
            } else {
                return
            }
            this.register_share.customShareParamsCB = customPageParamsFunc
        },
    },
    setupPlatformParams = function() {
        var platformKey = $('data-variables').attr('data-platform-key')

        if (platformKey === '') {
            return
        }

        function extractDomain(url) {
            var domain

            if (url.charAt(0) == '/') {
                return window.location.host
            }

            // find & remove protocol (http, ftp, etc.) and get domain
            if (url.indexOf('://') > -1) {
                domain = url.split('/')[2]
            } else {
                domain = url.split('/')[0]
            }

            // find & remove port number
            domain = domain.split(':')[0]

            return domain
        }

        // this function iterates through all links on the page and appends platform key param on all youvisit.com urls
        $('a').each(function() {
            var domain = extractDomain($(this).attr('href') || '')

            if (domain.indexOf('youvisit.com') > -1 && $(this).attr('data-platform') != 'false') {
                $(this).attr('href', Common.appendPlatformParam($(this).attr('href'), platformKey))
            }
        })
    },
    sendAnalytics = function(action, link) {
        const redirect = !!link || false

        const AJAX = {
            url: '/tour/Tour/registerAction',
            method: 'GET',
            data: {
                userkey: Analytics.userkey,
                sessionid: Analytics.sessionId,
                action: action,
                moduleid: Analytics.module,
            },
        }

        if (redirect) {
            AJAX['success'] = function() {
                window.location.href = link
            }
        }

        $.ajax(AJAX)
    },
    attachRegisterEventToButton = function(element, action, new_window) {
        new_window = !!new_window || false
        const link = $(element).attr('href')

        $(element).on(
            'click',
            (function(sendAnalytics, action, new_window, link) {
                if (new_window) {
                    return function(e) {
                        sendAnalytics(action)
                    }
                } else {
                    return function(e) {
                        e.preventDefault()
                        sendAnalytics(action, link)
                    }
                }
            })(sendAnalytics, action, new_window, link)
        )
    },
    setupCloseButton = function() {
        var url = window.location.href,
            showCloseBtn = false

        if (url.indexOf('hover=1') >= 0) {
            showCloseBtn = true
        }

        if (showCloseBtn) {
            $('header .menu-close-btn').show(0)
            $('header .menu-close-btn a').on('click', function(event) {
                parent.postMessage('closeHover', '*')
                event.stopPropagation()
            })
            $('header .branding a').attr('target', '_parent')
        }
    }

Common.init()

export default Common
